import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Input from '../../components/Input';
import styled from 'styled-components';
import BackgroundLogin from '../../assets/images/backgroundLogin.png';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import BackgroundVideo from '../../assets/video/map_login.mp4';
import Intercom from '../../components/Intercom';
import { onLogin } from '../../actions/auth';
import { I18n } from 'react-redux-i18n';
import getEnvVariable from '../../utils/env';
import history from '../../history';

const AuthContainer = styled.div`
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background-image: url(${BackgroundLogin});
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
    pointer-events: none;
    position: absolute;
  }

  .loginContentContainer {
    width: 15%;
    z-index: 2;
    min-width: ${(props) => (props.isIE ? '250px' : '350px')};
    min-height: ${(props) => (props.isIE ? '300px' : '450px')};
    display: flex;
    align-items: center;
    flex-direction: column;
    border: 10px solid white;
  }

  .resetInputContainer {
    margin-top: 10px;
  }

  .wrapperLoginContent {
    width: calc(100% - 100px);
    height: calc(100% - 80px);
    padding: ${(props) => (props.isIE ? '5px 10px' : '40px 50px')};
    border-radius: 4px;
    background-color: white;
    border: 1px solid #f0f0f0;
    max-height: 75vh;
  }

  .loginSeparator {
    height: 1px;
    background-color: #e8eaeb;
    margin-top: 27px;
    margin-bottom: ${(props) => (props.isIE ? '10px' : '30px')};
    width: 100%;
  }

  .loginTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    color: ${(props) => props.theme.colors.dark};
    margin-bottom: 20px;
  }

  .loginInputContainer {
    width: 100%;
    margin-bottom: 16px;
    position: relative;
  }

  .forgotPasswordText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    margin-left: auto;
    color: #02384a;
    opacity: 0.3;
    letter-spacing: -0.6px;
    text-decoration: underline;
  }

  .forgotPasswordText:hover {
    cursor: pointer;
  }

  .loginSubmitContainer {
    width: 100%;
    margin-top: 10px;
  }

  .loginSubmitContainer > div {
    width: 100%;
  }

  .hidePasswordIcon {
    position: absolute;
    font-size: 17px;
    right: 21px;
    top: 38px;
    color: #e8eaeb;
  }
  .hidePasswordIcon:hover {
    cursor: pointer;
  }

  .loginLogoContainer {
    width: ${(props) => (props.isIE ? '50%' : '66%')};
    ${(props) => props.isIE && `height: 70px;`}
  }

  .errorPassword {
    text-align: center;
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    height: 20px;
    margin-top: 20px;
    font-size: 12px;
  }
`;

const TooltipContent = styled.div`
  font-size: 12px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  > div {
    padding: 10px 20px;
  }
`;

class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isIE: true,
      username: '',
      password: '',
      showPassword: false,
      deployForget: false,
      email: ''
    };
  }

  componentDidMount() {
    this.setState({
      isIE: this.isIE()
    });
  }

  componentDidUpdate() {
    if (this.props.auth.isAuthenticated && window.location.pathname === '/') {
      history.push('/dashboard');
    }
  }

  renderEmailInput() {
    const { username } = this.state;
    return (
      <div className="loginInputContainer">
        <Input
          id="email"
          error={this.props.auth.error}
          label={I18n.t('auth.loginLabel')}
          value={username}
          tooltip={{
            placement: 'top',
            content: (
              <TooltipContent>
                <div>
                  <p>{I18n.t('auth.loginTooltip')}</p>
                </div>
              </TooltipContent>
            )
          }}
          autoCapitalize="none"
          onChange={(username) => this.setState({ username })}
          onKeyPress={(e) => {
            e.key === 'Enter' && this.props.login(this.state);
          }}
        />
      </div>
    );
  }

  async resetPassword() {
    const reactAppApiUrl = getEnvVariable('REACT_APP_API_URL');
    await axios
      .post(reactAppApiUrl + '/rest-auth/password/reset/', {
        email: this.state.email
      })
      .then(function () {
        alert('Un nouveau mot de passe a été envoyé sur votre email');
      })
      .catch(function () {
        alert('Veuillez renseigner votre email dans le bon champ');
      });
  }

  renderPasswordInput() {
    const { showPassword, password } = this.state;
    return (
      <div className="loginInputContainer">
        <Input
          id="password"
          error={this.props.auth.error}
          label="Mot de passe"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(password) => this.setState({ password })}
          onKeyPress={(e) => {
            e.key === 'Enter' && this.props.login(this.state);
          }}
        />
        <div
          className="hidePasswordIcon"
          onClick={() =>
            this.setState({ showPassword: !this.state.showPassword })
          }
        >
          {showPassword ? <Icon icon="eyeClosed" /> : <Icon icon="eye2" />}
        </div>
      </div>
    );
  }

  deployResetPassword() {
    this.setState({ deployForget: !this.state.deployForget });
  }

  renderResetPassword() {
    const { email } = this.state;
    return (
      <div className="resetInputContainer">
        <Input
          placeholder={I18n.t('auth.placeholderEmail')}
          value={email}
          onChange={(email) => this.setState({ email })}
        />
      </div>
    );
  }

  isIE() {
    return (
      /MSIE/.test(navigator ? navigator.userAgent : '') ||
      /Windows NT 6.3/.test(navigator ? navigator.userAgent : '') ||
      (window &&
        document &&
        !!window.MSInputMethodContext &&
        !!document.documentMode)
    );
  }

  render() {
    const { deployForget } = this.state;

    return (
      <AuthContainer isIE={this.state.isIE}>
        {!this.state.isIE && (
          <video
            autoPlay="autoplay"
            loop
            playsInline
            muted
            allowFullScreen
            src={BackgroundVideo}
            type="video/mp4"
            className="video"
          />
        )}
        <div className="loginContentContainer">
          <div className="wrapperLoginContent">
            <div className="loginLogoContainer">
              <Icon icon="logoBig" />
            </div>
            <div className="loginSeparator" />
            <h1 className="loginTitle">{I18n.t('auth.title')}</h1>
            {this.renderEmailInput()}
            {this.renderPasswordInput()}
            <p
              className="forgotPasswordText"
              onClick={() => this.deployResetPassword()}
            >
              {I18n.t('auth.forgotPassword')}
            </p>
            {deployForget && this.renderResetPassword()}
            <div className="errorPassword">
              {this.props.auth.error && <p>{I18n.t('auth.error')}</p>}
            </div>
            <div className="loginSubmitContainer">
              {deployForget ? (
                <Button
                  onClick={(email) => this.resetPassword(email)}
                  textTransform="normal"
                  label={I18n.t('auth.actionForgotPassword')}
                />
              ) : (
                <Button
                  id="login"
                  textTransform="normal"
                  label={I18n.t('auth.actionLogin')}
                  onClick={() => this.props.login(this.state)}
                />
              )}
            </div>
          </div>
        </div>
        <Intercom />
      </AuthContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: (authData) => {
    dispatch(onLogin(authData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
